export default function getZipFiles<T extends File>(files: T[]) {
  return []
}